import { ga } from 'js/analytics/adapters'
export const trackPlanTestStart = () => {
  ga.track('started_plan_test')
}
